import { apiBaseUrl } from '../util/api';

// Action types
const FETCH_CLAIMABLE_COMPANIES_REQUEST = 'claim/FETCH_CLAIMABLE_COMPANIES_REQUEST';
const FETCH_CLAIMABLE_COMPANIES_SUCCESS = 'claim/FETCH_CLAIMABLE_COMPANIES_SUCCESS';
const FETCH_CLAIMABLE_COMPANIES_ERROR = 'claim/FETCH_CLAIMABLE_COMPANIES_ERROR';
const CLAIM_COMPANY_REQUEST = 'claim/CLAIM_COMPANY_REQUEST';
const CLAIM_COMPANY_SUCCESS = 'claim/CLAIM_COMPANY_SUCCESS';
const CLAIM_COMPANY_ERROR = 'claim/CLAIM_COMPANY_ERROR';

// Initial state
const initialState = {
  claimableCompanies: [],
  fetchInProgress: false,
  fetchError: null,
  claimInProgress: false,
  claimError: null,
  claimSuccess: false,
};

// Reducer
export default function claimReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_CLAIMABLE_COMPANIES_REQUEST:
      return { ...state, fetchInProgress: true, fetchError: null };
    case FETCH_CLAIMABLE_COMPANIES_SUCCESS:
      return { ...state, fetchInProgress: false, claimableCompanies: action.payload, fetchError: null };
    case FETCH_CLAIMABLE_COMPANIES_ERROR:
      return { ...state, fetchInProgress: false, fetchError: action.error };
    case CLAIM_COMPANY_REQUEST:
      return { ...state, claimInProgress: true, claimError: null, claimSuccess: false };
    case CLAIM_COMPANY_SUCCESS:
      return { ...state, claimInProgress: false, claimError: null, claimSuccess: action.payload };
    case CLAIM_COMPANY_ERROR:
      return { ...state, claimInProgress: false, claimError: action.error, claimSuccess: false };
    default:
      return state;
  }
}

// Action creators
export const fetchClaimableCompaniesRequest = () => ({ type: FETCH_CLAIMABLE_COMPANIES_REQUEST });
export const fetchClaimableCompaniesSuccess = companies => ({ type: FETCH_CLAIMABLE_COMPANIES_SUCCESS, payload: companies });
export const fetchClaimableCompaniesError = error => ({ type: FETCH_CLAIMABLE_COMPANIES_ERROR, error });
export const claimCompanyRequest = () => ({ type: CLAIM_COMPANY_REQUEST });
export const claimCompanySuccess = (response) => ({ type: CLAIM_COMPANY_SUCCESS, payload: response });
export const claimCompanyError = error => ({ type: CLAIM_COMPANY_ERROR, error });

// Thunks
export const fetchClaimableCompanies = (ytunnus = null) => async dispatch => {
  dispatch(fetchClaimableCompaniesRequest());
  try {
    const baseUrl = apiBaseUrl();
    const path = ytunnus ? 
      `/api/telia/claimable-companies?ytunnus=${ytunnus}` : 
      '/api/telia/claimable-companies';
    const url = `${baseUrl}${path}`;
    
    console.log('Fetching claimable companies from:', url);
    const res = await fetch(url, {
      credentials: 'include', // Include cookies/session
      headers: {
        'Content-Type': 'application/json',
      },
    });
    
    console.log('Response status:', res.status);
    console.log('Response headers:', res.headers);
    
    if (!res.ok) {
      const text = await res.text();
      console.error('API response not ok:', res.status, text);
      throw new Error(`Failed to fetch claimable companies: ${res.status}`);
    }
    
    const text = await res.text();
    console.log('Raw response:', text.substring(0, 200) + '...');
    
    let data;
    try {
      data = JSON.parse(text);
    } catch (parseError) {
      console.error('JSON parse error:', parseError);
      console.error('Response text:', text);
      throw new Error('Invalid JSON response from server');
    }
    
    dispatch(fetchClaimableCompaniesSuccess(data.companies));
  } catch (err) {
    console.error('fetchClaimableCompanies error:', err);
    dispatch(fetchClaimableCompaniesError(err.message));
  }
};

export const claimCompany = companyId => async dispatch => {
  dispatch(claimCompanyRequest());
  try {
    const baseUrl = apiBaseUrl();
    const url = `${baseUrl}/api/telia/claim-company`;
    
    const res = await fetch(url, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ companyId }),
    });
    
    if (!res.ok) {
      const errData = await res.json();
      throw new Error(errData.error || 'Failed to claim company');
    }
    
    const responseData = await res.json();
    console.log('Claim company response:', responseData);
    
    // Pass the full response to the success action
    dispatch(claimCompanySuccess(responseData));
  } catch (err) {
    dispatch(claimCompanyError(err.message));
  }
};
